import { Link, useSearchParams } from 'react-router-dom'
import { LoginForm } from '../components/LoginForm'
import { useRegistrationStatus } from '../hooks/useRegistrationStatus'

export const LoginPage = () => {
  const [searchParams] = useSearchParams()
  const verified = searchParams.get('verified') === 'true'
  const { data: registrationStatus } = useRegistrationStatus()
  // hidden by default — only render the register link after the server
  // confirms registration is enabled
  const canRegister = registrationStatus?.allowed === true

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-4">
        <div className="flex justify-center">
          <img src="/vectorFP3Logo.svg" alt="FP3 Finance" className="h-24" />
        </div>
        {verified && (
          <div className="p-3 text-sm text-foreground bg-success/10 border border-success/30 rounded-md">
            Email verified successfully. You can now log in.
          </div>
        )}
        <LoginForm />
        <div className="text-center space-y-2">
          <p className="text-sm text-muted-foreground">
            <Link to="/forgot-password" className="text-primary hover:underline font-medium">
              Forgot password?
            </Link>
          </p>
          {canRegister && (
            <p data-testid="auth-login-register-prompt" className="text-sm text-muted-foreground">
              Don't have an account?{' '}
              <Link
                data-testid="auth-login-register-link"
                to="/register"
                className="text-primary hover:underline font-medium"
              >
                Create one
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
